import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ResetPassword } from "@/app/(guest)/forgot-password/reset-password/$id/_components/reset-password.tsx";

const validateUid = z.string().uuid();

export const Route = createFileRoute(
  "/(guest)/forgot-password/reset-password/$id/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const id = Route.useParams();
  const validatedId = validateUid.safeParse(id);
  if (validatedId.error) throw new Error("Invalid id");
  return <ResetPassword id={validatedId.data} />;
}
